import { Injectable, signal, computed } from '@angular/core';

export type NotifType = 'success' | 'error' | 'warning' | 'info';

export interface Notification {
  id: string;
  type: NotifType;
  title: string;
  message: string;
  timestamp: Date;
  read: boolean;
  jobId?: string;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private _items = signal<Notification[]>([]);

  readonly items = this._items.asReadonly();
  readonly unreadCount = computed(() => this._items().filter(n => !n.read).length);

  push(type: NotifType, title: string, message: string, jobId?: string): void {
    const notif: Notification = {
      id: crypto.randomUUID(),
      type, title, message, jobId,
      timestamp: new Date(),
      read: false,
    };
    this._items.update(list => [notif, ...list].slice(0, 50));
  }

  markAllRead(): void {
    this._items.update(list => list.map(n => ({ ...n, read: true })));
  }

  markRead(id: string): void {
    this._items.update(list => list.map(n => n.id === id ? { ...n, read: true } : n));
  }

  clear(): void {
    this._items.set([]);
  }
}
